import React from 'react';

import CertificateImage from 'assets/images/pages/explore/pharmuni-certificate.png';
import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './IsoCertificate.module.scss';

const IsoCertificate = () => {
    return (
        <div className={classes['wrapper']}>
            <div className={`container row d-flex justify-content-center`}>
                <div className='col-lg-10 col-12'>
                    <div className="row">
                        <div className='col-lg-4 col-12 d-flex flex-column justify-content-center align-items-center'>
                            <img src={CertificateImage.src} alt='pharmuni_certificate' />
                        </div>
                        <div className='col-lg-8 col-12 d-flex flex-column justify-content-center align-items-center gap-3'>
                            <h2>Earn ISO-Backed Pharma Certificates</h2>
                            <h5>
                                Industry-recognized credentials with unique verification codes
                            </h5>
                            <p>
                                Earn an industry-recognised certificate under Zamann’s  ISO 9001-certified system — with a one-click validation badge to prove your GMP or pharmacovigilance expertise to employers.
                            </p>
                            <LinkButton kind='primary-color' to={'/pharmuni-certificate/'}>
                                Learn About Pharmuni Certificates
                            </LinkButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IsoCertificate;